import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { IConfirmationDialogData } from './shared/interfaces/IConfirmationDialogData';
import { NotificationService } from './shared/services/notification.service';
import { INewsCreateUpdateItem } from './shared/interfaces/news/INews';

export class AppOperations {
  public static getReleaseNotesDialogData(): IConfirmationDialogData {
    return {
      title: 'new-release.title',
      desc: 'new-release.description',
      confirmationBtnText: 'new-release.button',
      isWarning: false,
    };
  }

  public static showErrorMessage(notificationService: NotificationService, messagei18nKey: string): Observable<null> {
    notificationService.showMessage({
      type: 'Error',
      title: 'default.error',
      desc: messagei18nKey,
    });
    return of(null);
  }

  public static isLastVisitTimeBeforeRelease(currentRelease: Date): boolean {
    const lastUpdate = new Date(currentRelease);
    const lastVisit = new Date(localStorage.getItem('lastVisitTime'));
    return lastVisit.getTime() < lastUpdate.getTime();
  }

  public static isLastVisitTimeBeforeLatestCurrentNews(currentNews: INewsCreateUpdateItem[]): boolean {
    const lastActiveNews = new Date(Math.max(...currentNews.map(news => new Date(news.startDate).getTime())));
    const lastVisit = new Date(localStorage.getItem('lastVisitNewsTime'));
    return lastVisit.getTime() < lastActiveNews.getTime();
  }

  public static setLastVisitTime(): void {
    localStorage.setItem('lastVisitTime', new Date().toISOString());
  }

  public static setLastVisitNewsTime(): void {
    localStorage.setItem('lastVisitNewsTime', new Date().toISOString());
  }

  public static navigateToReleaseNotes(router: Router) {
    void router.navigate(['/release-notes']);
  }
}
